// Railway-edge continuation: six existing footprints, no world or collision edits.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc,alpha,text} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const RAIL_STUDY_BUILDINGS=['ks-flats-w','ks-office-w','ks-flats-m','ks-bar-m','ks-office-m','ks-flats-se'] as const;
function rail(g:G,x:number,y:number,w:number){px(g,x,y,w,2,K.metalHi);px(g,x,y+14,w,3,K.metalLo);for(let j=0;j<w;j+=9)px(g,x+j,y,2,15,K.metal);}
function louver(g:G,x:number,y:number,w:number,h:number){panel(g,x,y,w,h,K.metalLo);for(let j=4;j<h-3;j+=4)px(g,x+3,y+j,w-6,1,K.metalHi);}
export function paintKabukiRailStudy(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(RAIL_STUDY_BUILDINGS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh,flats=b.kind==='apartment',bar=b.kind==='bar';
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 // Keep original roof materials and equipment, adding small occupied service spaces.
 pipe(g,x+w-12,y+12,rh-24);
 if(flats){
  panel(g,x+20,y+33,69,44,K.wallLo);louver(g,x+27,y+40,24,31);px(g,x+55,y+42,25,18,K.glassLo);
  // Laundry is contained on the roof; no wires or props cross the public path.
  const lx=x+105,lw=w-131;px(g,lx,y+31,lw,1,K.metalHi);
  for(let j=0;j<Math.floor(lw/27);j++){const xx=lx+7+j*27;px(g,xx,y+31,2,5,K.woodHi);px(g,xx-3,y+35,15,18,j%2?K.woodLo:K.concreteHi);px(g,xx-2,y+51,13,2,K.metalLo);}
  for(let j=0;j<Math.floor(lw/46);j++){const xx=lx+j*46;panel(g,xx,y+67,33,12,K.woodLo);for(let k=0;k<3;k++){disc(g,xx+7+k*9,y+66,4,5,K.metalLo);px(g,xx+7+k*9,y+64,1,8,K.woodHi);}}
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,8);
  const n=Math.floor((w-20)/70),step=(w-20)/n;
  for(let j=0;j<n;j++){
   const xx=Math.round(x+10+j*step),bw=Math.floor(step)-8;
   window(g,xx+7,fy+9,bw-14,30,j%3===1?K.glassLo:K.amber);
   px(g,xx+9,fy+11,8,26,K.woodLo);px(g,xx+bw-17,fy+11,8,26,K.woodLo);
   px(g,xx,fy+38,bw,14,K.wallLo);rail(g,xx,fy+37,bw);
   panel(g,xx+8,fy+61,25,30,K.metalLo);px(g,xx+27,fy+75,2,4,K.amber);
   text(g,String(j+1).padStart(2,'0'),xx+13,fy+64,K.white,1);
   panel(g,xx+39,fy+67,18,16,K.metalLo);for(let k=0;k<3;k++)px(g,xx+42,fy+70+k*4,12,1,K.metalHi);
   px(g,xx+10,fy+57,21,2,K.warmHi);L(xx+10,fy+56,21,3,K.amber,.17,true);
  }
 }else if(bar){
  panel(g,x+133,y+19,99,59,K.wallLo);louver(g,x+141,y+28,26,43);label(g,'BAR',x+178,y+33,43,K.white);
  fan(g,x+24,y+48);fan(g,x+60,y+48);px(g,x+94,y+56,39,9,K.metalLo);px(g,x+96,y+57,35,2,K.metalHi);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.woodHi,K.woodLo,8);
  for(let j=8;j<w-8;j+=14)px(g,x+j,fy+4,2,87,K.woodLo);
  label(g,'バー',x+w/2-60,fy+7,120,K.pink,3);
  for(const xx of [x+22,x+w-116]){
   window(g,xx,fy+48,94,38,K.amber);px(g,xx+4,fy+73,86,4,K.woodHi);
   for(let j=9;j<86;j+=13){px(g,xx+j,fy+59,6,12,j%2?K.woodHi:K.metalLo);px(g,xx+j+2,fy+56,2,4,K.metalHi);}
  }
  panel(g,x+w/2-22,fy+46,44,47,K.ink);window(g,x+w/2-17,fy+51,34,29,K.amber);px(g,x+w/2+12,fy+82,3,3,K.amber);
  px(g,x+13,fy+40,w-26,5,K.ink);px(g,x+13,fy+40,w-26,1,K.pink);
  for(const xx of [x+15,x+w-15]){disc(g,xx,fy+62,6,10,K.amber);px(g,xx-4,fy+53,8,2,K.woodLo);px(g,xx-4,fy+70,8,2,K.woodLo);}
  L(x+w/2-53,fy+14,106,22,K.pink,.25,true);
 }else{
  // Small offices use a ducted plant and a shallow rooflight, rather than neon retail signs.
  panel(g,x+22,y+33,92,45,K.metalLo);fan(g,x+29,y+40);fan(g,x+65,y+40);
  px(g,x+113,y+48,45,10,K.metalLo);px(g,x+114,y+49,42,2,K.metalHi);
  window(g,x+169,y+29,70,43,K.glassLo);for(let j=1;j<4;j++)px(g,x+170+j*17,y+30,2,40,K.metalHi);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,8);
  for(let j=0;j<5;j++){const xx=x+18+j*58;window(g,xx,fy+10,45,28,j%3?K.glassLo:K.amber);px(g,xx+3,fy+29,39,2,K.metalLo);}
  px(g,x+7,fy+43,w-14,4,K.metalLo);px(g,x+7,fy+43,w-14,1,K.concreteHi);
  window(g,x+w/2-24,fy+54,48,39,K.amber);px(g,x+w/2-1,fy+57,2,32,K.metalLo);
  for(const xx of [x+22,x+w-100]){window(g,xx,fy+57,78,28,K.glassLo);for(let j=5;j<24;j+=5)px(g,xx+3,fy+57+j,72,1,K.metal);}
  label(g,'OFFICE',x+w/2-35,fy+43,70,K.white);L(x+w/2-19,fy+65,38,23,K.amber,.12,true);
 }
 px(g,x+2,y+h-4,w-4,3,K.ink);frame(g,x+2,fy+2,w-4,h-rh-4,alpha(K.ink,.6));g.restore();
}
